export enum ROOTS {
  WELCOME = '/:projectCode/:buildingId/graph',
  AUTH = '/',
  CHANGE_COMPANY = '/change-company',
  CHANGE_PROJECT = '/change-project',
}
